<script>
    import { scale, fade } from 'svelte/transition';
    import { quintOut } from 'svelte/easing';

    import { user } from '../store/authStore';
    import { users } from '../store/users';
    import { page, modal } from '../store/nav';
    import Icon from "../components/icon.svelte";

</script>

{#if $user.isLoggedIn}
    <section id="home" out:scale="{{delay: 250, duration: 300, easing: quintOut }}" class="z-0 bg-gradient-to-br from-bright_accent to-dark_accent fixed top-0 left-0 h-screen w-screen font-primaryBold text-secondary flex flex-col pt-5 pb-3 px-7" > 
        <div id="home-user-profile" on:click={() => page.route('/profile')} class="fixed top-5 right-5" >
            {#if $user.isLoggedIn}
                {#if $user.isAnonymous }
                    <div class="btn-sm w-10 h-10 cursor-pointer">
                        <Icon name="user" class="rounded-full" />
                    </div>
                {:else}
                    <div class="btn-sm w-10 h-10 cursor-pointer">
                        <img src="{$user.photoURL}" class="rounded-full border-2 border-secondary" alt="U" referrerpolicy="no-referrer">
                    </div>
                {/if}
            {:else}
                <div class="btn-sm w-10 h-10 cursor-pointer">
                    <img src="#" class="rounded-full border-2 border-secondary" alt="U" referrerpolicy="no-referrer">
                </div>
            {/if}
        </div>
        <section id="menu" class="flex flex-col grow justify-between ">
            <section id="plan" class="flex flex-col m-auto" on:click|stopPropagation={() => modal.open('/message?anchor=bottom&text=The planning section is not available in this version. We\'re hard at work to release it as soon as possible. Thank you for your patience ❤︎')} >
                <img src="/img/icon/plan.png" class="w-24" alt="">
                <span class="text-center">Plan</span>
            </section>
            <section id="shop" class="flex flex-col m-auto" on:click|stopPropagation={() => page.route('/lists')}>
                <img src="/img/icon/shop.png" class="w-24" alt="">
                <span class="text-center">Shop</span>
            </section>
            <section id="cook" class="flex flex-col m-auto" on:click|stopPropagation={() => modal.open('/message?anchor=bottom&text=The Cooking section is not available in this version. We\'re hard at work to release it as soon as possible. Thank you for your patience ❤︎')}>
                <img src="/img/icon/cook.png" class="w-24" alt="">
                <span class="text-center">Cook</span>
            </section>
        </section>
    </section>
{:else}
    <section class="z-0 fixed top-0 left-0 h-screen w-screen bg_gradient"   out:fade="{{delay: 250, duration: 300, easing: quintOut }}" >
        <!--img src="/img/icon/system/loading.gif" class="opacity-25 m-auto place-self-center" alt=""-->
    </section> 
{/if}


<style lang="postcss">
</style>
